<template>
  <div class="incidents-info">
    <b-row class="mb-3">
      <b-col>
        <b-card
          class="py-2 incident-card float-component-bordered"
          qa="incident-card"
          :class="{'close-color': incident.closingDate}"
        >
          <b-row class="my-2">
            <b-col>
              <span class="ap-title ap-title__subtitle">{{ incident.incLabel }}</span>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col cols="12">
              <div class="d-flex flex-column">
                <small>{{ $t('component.incidentModal.area') }}</small>
                <span class="header">{{ incident.incidentOrigin.description }}</span>
              </div>
            </b-col>
            <b-col
              cols="12"
              class="mt-2"
            >
              <div class="d-flex flex-column">
                <small>{{ $t('component.incidentModal.type') }}</small>
                <span class="header">{{ incident.incidentType.description }}</span>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-row>
                <b-col
                  cols="auto"
                  class="pr-0"
                >
                  <div style="position:relative; height:100%;">
                    <div class="tl-circle mt-1 d-flex align-items-center justify-content-center">
                      <i
                        class="far fa-exclamation"
                        aria-hidden="true"
                      />
                    </div>
                    <div
                      v-if="incident.closingDate"
                      class="tl"
                    />
                  </div>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col
                      cols="auto"
                      class="d-flex align-items-center mb-1"
                    >
                      <b-badge
                        pill
                        variant="light"
                        style="width: 70px"
                      >
                        {{ $t('component.incidentModal.opening') }}
                      </b-badge>

                      <vt-personnel-profile-image
                        v-if="incident.openedBy"
                        :personnel-id="incident.openedBy.id"
                        :img-tooltip="`${$tc('component.incidentModal.openuser')}:<br>${incident.openedBy.fullName}`"
                        img-class="mx-3"
                      />

                      <span class="date"><i
                        v-tooltip="$t('component.incidentModal.opendate')"
                        class="far fa-calendar mr-1"
                        aria-hidden="true"
                      />{{ incident.openingDate | datetime }}</span>
                    </b-col>
                    <b-col cols="12">
                      <p>{{ incident.openingObservations }}</p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row v-if="incident.closingDate">
                <b-col
                  cols="auto"
                  class="pr-0"
                >
                  <div class="tl-circle end mt-1 d-flex align-items-center justify-content-center">
                    <i
                      class="far fa-times"
                      aria-hidden="true"
                    />
                  </div>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col
                      cols="auto"
                      class="d-flex align-items-center mb-1"
                    >
                      <b-badge
                        pill
                        variant="light"
                        style="width: 70px"
                      >
                        {{ $t('component.incidentModal.closing') }}
                      </b-badge>

                      <vt-personnel-profile-image
                        :personnel-id="closedById"
                        :img-tooltip="`${$tc('component.incidentModal.closeuser')}:<br>${incident.closedBy ? incident.closedBy.fullName : ''}`"
                        img-class="mx-3"
                        img-style="width: 18px"
                      />

                      <span class="date"><i
                        v-tooltip="$t('component.incidentModal.closedate')"
                        class="far fa-calendar mr-1"
                        aria-hidden="true"
                      />{{ incident.closingDate | datetime }}</span>
                    </b-col>
                    <b-col cols="12">
                      <p>{{ incident.closingObservations }}</p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
    name: 'IncidentCard',
    props: {
        incident: { type: Object, required: true }
    },
    computed: {
        closedById() {
            return this.incident.closedBy && this.incident.closedBy.id
        }
    }
}
</script>

<style lang="scss">
    .incident-card {
        border-left: 3px solid vt-color(red);
    }
    .incident-card.close-color {
        border-left-color: vt-color(green-radiant);
    }
    .incident-card .header {
        margin-top: -4px;
        color: #000;
        font-size: 14px;
    }
    .incident-card .tl-circle {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: vt-color(red);
    }
    .incident-card .tl-circle.end {
        background: vt-color(green-radiant);
    }
    .incident-card .tl-circle i {
        font-size: 12px;
        color: #FFF;
    }
    .incident-card .tl {
        width: 3px;
        height: calc(100% - 18px);
        background: vt-color(base-text, .7);
        position: absolute;
        top: 18px;
        margin-left: 7.5px;
    }
    .incident-card img {
        width: 25px !important;
        height: 25px !important;
        cursor: pointer;
        border-radius: 50%;
    }
    .incident-card p {
        font-size: 12px;
    }
    .incident-card .date {
        font-size: 12px;
    }
</style>
